// @flow

import IframeChallenge from './IframeChallenge';
import isSamsungBuiltinBrowser from '../../../lib/isSamsungBuiltinBrowser';


class UnrulyChallenge extends IframeChallenge {
    static disablesSupportButton() {
        return true;
    }

    iFrameSource() {
        const baseUrl = (window.location.origin || (
            window.location.protocol +
            "//" +
            window.location.hostname +
            (window.location.port ? ':' + window.location.port: '')
        )) + '/';

        const params = {
            baseUrl,
            unrulyId: this.props.challenge.placement,
            idfa: this.props.params.queryParams.device_ifa,
        };

        const queryString = Object.keys(params)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key] || '')}`)
            .join('&');


        return `/unruly_appwrap.html?${queryString}`;
    }

    static isSupportedOnCurrentPlatform() {
        return !isSamsungBuiltinBrowser();
    }

    static shouldShowSkipButtonOnStart() {
        return false;
    }

    eventComplete() {
        this.trackImpression(() => super.eventComplete());
        this.trackAdOpportunity(true);
    }

    eventPassback() {
        this.trackAdOpportunity(false);
        super.eventPassback();
    }
}

export default UnrulyChallenge;



// WEBPACK FOOTER //
// ./src/campaign/challenges/external-sdks/UnrulyChallenge.jsx